'use client';

import { useEffect } from 'react';

import { ErrorPageContent } from '@/components/ErrorPageContent';

type ErrorProps = {
  readonly error: Error & { digest?: string };
  readonly reset: () => void;
};

export default function PageErrorBoundary({ error, reset }: ErrorProps) {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('[page error boundary]', error);
  }, [error]);

  return <ErrorPageContent reset={reset} />;
}
